var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E7FCE8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_894_10050)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23483 11.9848C9.38128 11.8384 9.61872 11.8384 9.76516 11.9848L11 13.2197L14.2348 9.98484C14.3813 9.83839 14.6187 9.83839 14.7652 9.98484C14.9116 10.1313 14.9116 10.3687 14.7652 10.5152L11.2652 14.0152C11.1187 14.1616 10.8813 14.1616 10.7348 14.0152L9.23483 12.5152C9.08839 12.3687 9.08839 12.1313 9.23483 11.9848Z",
    fill: "#26A04B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.375C9.44568 7.375 7.375 9.44568 7.375 12C7.375 14.5543 9.44568 16.625 12 16.625C14.5543 16.625 16.625 14.5543 16.625 12C16.625 9.44568 14.5543 7.375 12 7.375ZM6.625 12C6.625 9.03147 9.03147 6.625 12 6.625C14.9685 6.625 17.375 9.03147 17.375 12C17.375 14.9685 14.9685 17.375 12 17.375C9.03147 17.375 6.625 14.9685 6.625 12Z",
    fill: "#26A04B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_894_10050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublished);
export default __webpack_public_path__ + "static/media/published.a6a1fd9b009c5df989d15a42e0ea2504.svg";
export { ForwardRef as ReactComponent };